// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__2ftqE","react-quill-text":"styles_react-quill-text__CsaTC","moodboard-text-react-quill":"styles_moodboard-text-react-quill__1-BWe"};